export enum OfferInvoiceState {
    QUOTE = 0, //devis avant la souscription d'un abonnement
    SCHEDULED_PAYMENT = 1, //facture programmé pour être payée automatiquement
    CANCELED = 2, //facture annulée
    PAYMENT_SUCCEEDED = 3, //facture payée
    PAYMENT_FAILED = 4, //facture non payée (défaut de paiement)
    PAYMENT_ACTION_REQUIRED = 5
}